import { useRouter } from 'next/router';

import { PageFullType } from '@tager/web-modules';

import { getCurrentPath } from '@/utils/common';
import { selectPageByPath } from '@/store/reducers/tager/pages';
import { useTypedSelector } from '@/store/store';

function useCurrentPage<P extends PageFullType>(): P {
  const router = useRouter();

  const currentPath = getCurrentPath(router.route, router.query.slug);

  const foundPage = useTypedSelector((state) =>
    selectPageByPath<P>(state, currentPath)
  );

  if (!foundPage) {
    throw new Error('Page not found');
  }

  return foundPage;
}

export default useCurrentPage;
